import {useMemo} from 'react';
import {useBreakpointDown, useBreakpointBetween, useBreakpointUp} from '@bonprix/design-system';

export const useAlpiSwatchOuterGap = () => {

    const breakpointIsLDown = useBreakpointDown('xl'); // 0-991px
    const isBreakPointXlOrXXL = useBreakpointBetween('xl', 'xxxl'); // 992-1599px
    const isBreakPointXXXL = useBreakpointUp('xxxl'); // 1600px+
    const outerGap = useMemo(() => {
        if(breakpointIsLDown) { // S-L: 360-991px
            return 16
        }
        if(isBreakPointXlOrXXL) { // XL-XXL: 992-1599px
            return 32
        }
        // 3XL: 1600-1900px (and above)
        return 48
    }, [breakpointIsLDown, isBreakPointXlOrXXL, isBreakPointXXXL]);

    return outerGap;
}